import React, { useState } from 'react';
import { Page, List, Icon, Card } from 'react-onsenui';
import './list.css'
import Anaf from './anaf/anaf'



export default (props) => {
    const subList = (row, index) => {
       return <List
                key={index}
                className="menuList"
                dataSource={row.prod}
                renderRow={(row, idx) => (
                    <Card key={idx} className="menuItem">
                    <div>
                        {
                            row.name_ro ?
                                <p className="menuItemTitle">
                                    {row.name_ro}
                                    {
                                        row.pers_ro ?
                                            <span className="pers">
                                                {row.pers_ro}
                                            </span>
                                            :
                                            null
                                    }
                                </p>
                                : null
                        }
            
                        {
                            row.desc_ro ?
                                <p className="menuItemDesc">
                                    {row.desc_ro}
                                </p>
                                : null
                        }
                        {
                            row.name_eng ?
                                <p className="menuItemTitle eng">
                                    {row.name_eng}
                                    {
                                        row.pers_eng ?
                                            <span className="pers">
                                                {row.pers_eng}
                                            </span>
                                            :
                                            null
                                    }
                                </p>
                                : null
                        }
                        {
                            row.desc_eng ?
                                <p className="menuItemDesc eng">
                                    {row.desc_eng}
                                </p>
                                : null
                        }
                        {
                            row.alergeni ?
                                <p className="menuItemAlerg">
                                    Alegeni : {row.alergeni}
                                </p>
                                :
                                null
                        }
                        <div className="menuItemPrice">
                            <span style={{ marginRight: 10, color: "#000", fontWeight: "normal" }}>
                                {row.gramaj}
                            </span>
                            <span>
                                {
                                    row.price ?
                                        row.price +" RON"
                                    :null
                                }
                            </span>
                        </div>
                    </div>
                </Card>
                )}
            />
        
    }

    return (
        <Page className="pageMenuList">
            <List
                key={0+"mancaruri"}
                style={{maginTop: 88}}
                className="menuList"
                dataSource={props.data.sucategories}
                renderRow={(row, index) => <div>
                    {subList(row, index)}
                </div>}
            />
            <div className="footer"> 
                  <Anaf/>                     
            </div>
        </Page>
    );
}
